import * as l from "react";
import { composeRefs as y } from "../../../../../@radix-ui_react-compose-refs@1.1.2_@types_react@19.2.14_react@19.2.4/bundled_deps/@radix-ui/react-compose-refs/dist/index.js";
import { j as p } from "../../../../../../../_virtual/jsx-runtime.js";
// @__NO_SIDE_EFFECTS__
function b(e) {
  const t = /* @__PURE__ */ S(e), r = l.forwardRef((o, n) => {
    const { children: i, ...a } = o, s = l.Children.toArray(i), c = s.find(g);
    if (c) {
      const f = c.props.children, m = s.map((u) => u === c ? l.Children.count(f) > 1 ? l.Children.only(null) : l.isValidElement(f) ? f.props.children : null : u);
      return /* @__PURE__ */ p.jsx(t, { ...a, ref: n, children: l.isValidElement(f) ? l.cloneElement(f, void 0, m) : null });
    }
    return /* @__PURE__ */ p.jsx(t, { ...a, ref: n, children: i });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function S(e) {
  const t = l.forwardRef((r, o) => {
    const { children: n, ...i } = r;
    if (l.isValidElement(n)) {
      const a = x(n), s = E(i, n.props);
      return n.type !== l.Fragment && (s.ref = o ? y(o, a) : a), l.cloneElement(n, s);
    }
    return l.Children.count(n) > 1 ? l.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var d = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function h(e) {
  const t = ({ children: r }) => /* @__PURE__ */ p.jsx(p.Fragment, { children: r });
  return t.displayName = `${e}.Slottable`, t.__radixId = d, t;
}
function g(e) {
  return l.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === d;
}
function E(e, t) {
  const r = { ...t };
  for (const o in t) {
    const n = e[o], i = t[o];
    /^on[A-Z]/.test(o) ? n && i ? r[o] = (...s) => {
      const c = i(...s);
      return n(...s), c;
    } : n && (r[o] = n) : o === "style" ? r[o] = { ...n, ...i } : o === "className" && (r[o] = [n, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function x(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
export {
  b as createSlot,
  h as createSlottable
};
